import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../api/client';
import { endpoints } from '../../../api/endpoints';
import type { SkipJobListResponse } from '../../../types/api';

export function useSkipPendingRequestsCount() {
  return useQuery<number>({
    queryKey: ['skip-pending-requests-count'],
    queryFn: async () => {
      const res = await apiClient.get<SkipJobListResponse>(
        endpoints.skipEnquiries.pendingRequests,
        { params: { limit: 1 } },
      );
      return res.data.pagination.total;
    },
    staleTime: 30_000,
    refetchInterval: 60_000,
  });
}
